import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import routes from "./routes";
import { Loading } from "./components";
import { axios } from "./boot";
import { convertPhone, scrollToTop, toast } from "./methods";
import "animate.css/animate.min.css"

export default function App() {
  const navigation = useNavigate()
  const location = useLocation();
  const dispatch = useDispatch();
  const isLogged = useSelector((s) => s.isLogged);
  const role = useSelector((s) => s.role);
  const elements = useRoutes(routes(isLogged, role));
  const setProfile = (data = {}) => {
    dispatch({ type: "SET_PROFILE", data });
  };
  const getProfile = () => {
    if (!isLogged) return;
    const url = "/users/me";
    axios.get(url).then(({ data }) => {
      setProfile({ ...data, phone: convertPhone(data.phone) });
      navigation("/admin/purchases-course")
    });
  };
  // const clearCaches = () => {
  //   if ('caches' in window) {
  //     caches.keys().then((names) => {
  //       names.forEach(name => { caches.delete(name); })
  //     })
  //   }
  // }
  // useEffect(clearCaches,[])
  useEffect(getProfile, [isLogged]);
  useEffect(scrollToTop, [location.pathname]);
  return (
    <React.Fragment>
      <h1 className="d-none">آکادمی مارول ترید</h1>
      <Toaster position="top-center" reverseOrder={false} />
      {elements}
      <Loading />
    </React.Fragment>
  );
}
